"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlardarSDKUrlMap = exports.SlardarPluginPathPrefix = exports.SlardarReportDomain = exports.NAME = exports.BID = exports.VERSION = void 0;
const i18n_1 = require("../../i18n");
exports.VERSION = '1.14.1';
exports.BID = 'n_webapp_main';
exports.NAME = 'Slardar';
exports.SlardarReportDomain = {
    [i18n_1.ClientBuildRegion.VA]: 'mon-va.lemon8-app.com',
    [i18n_1.ClientBuildRegion.SG]: 'mon-va.lemon8-app.com',
    [i18n_1.ClientBuildRegion.OCI]: 'mon-ttp.lemon8-app.us',
};
exports.SlardarPluginPathPrefix = {
    [i18n_1.ClientBuildRegion.VA]: 'https://lf-lemon8-web-va.ttwstatic.com/obj/lemon8-web-us/slardar/fe/sdk-web/plugins',
    [i18n_1.ClientBuildRegion.SG]: 'https://lf-lemon8-web-sg.ttwstatic.com/obj/lemon8-web-sg/slardar/fe/sdk-web/plugins',
    [i18n_1.ClientBuildRegion.OCI]: 'https://lf-lemon8-web.tiktokcdn-us.com/obj/static-tx/slardar/fe/sdk-web/plugins',
};
exports.SlardarSDKUrlMap = {
    [i18n_1.ClientBuildRegion.VA]: `https://lf-lemon8-web-va.ttwstatic.com/obj/lemon8-web-us/slardar/fe/sdk-web/browser.${exports.VERSION}.maliva.js`,
    [i18n_1.ClientBuildRegion.SG]: `https://lf-lemon8-web-sg.ttwstatic.com/obj/lemon8-web-sg/slardar/fe/sdk-web/browser.${exports.VERSION}.sg.js`,
    [i18n_1.ClientBuildRegion.OCI]: `https://lf-lemon8-web.tiktokcdn-us.com/obj/static-tx/slardar/fe/sdk-web/browser.${exports.VERSION}.oci.js`,
};
